/* MoRetro Studio - Etat des impressions personnelles dans le bandeau Atelier. */
window.MTS = window.MTS || {};

(function(MTS){
  "use strict";

  function normalizedPrinterName(value){
    const low = String(value || "").trim().toLowerCase().replace(/\s+/g, " ");
    if(low.includes("ender") && (low.includes("#1") || /(?:^|\s)1(?:\s|$)/.test(low))) return "Ender 3 V3 SE #1";
    if(low.includes("ender") && (low.includes("#2") || /(?:^|\s)2(?:\s|$)/.test(low))) return "Ender 3 V3 SE #2";
    if(low.includes("sidewinder") || low.includes("x4")) return "Sidewinder X4 Plus";
    if(low.includes("kobra")) return "Kobra S1";
    if(low.includes("p2s") && (low.includes("#1") || /(?:^|\s)1(?:\s|$)/.test(low))) return "P2S #1";
    if(low.includes("p2s") && (low.includes("#2") || /(?:^|\s)2(?:\s|$)/.test(low))) return "P2S #2";
    if(low === "p2s") return "P2S #1";
    if(low.includes("h2d")) return "H2D";
    return String(value || "").trim();
  }

  function machineState(machine = {}){
    const telemetry = machine.telemetry || machine;
    return String(
      telemetry.state || telemetry.status || telemetry.printerState ||
      telemetry.jobState || telemetry.printState || ""
    ).trim().toLowerCase().replace(/[\s_-]+/g, " ");
  }

  function isPrinting(machine){
    const state = machineState(machine);
    return /running|printing|print in progress|in progress|working|busy|processing|preparing|heating|resuming/.test(state) &&
      !/finish|complete|done|idle|ready|offline|error|failed/.test(state);
  }

  function machines(){
    try{
      return MTS.WorkshopMachines?.printerList?.() || MTS.Workshop?.printerList?.() || [];
    }catch(e){
      return [];
    }
  }

  function saveOriginal(dot){
    if(dot.dataset.personalPrintSaved === "1") return;
    dot.dataset.personalPrintSaved = "1";
    dot.dataset.personalPrintClass = dot.className;
    dot.dataset.personalPrintText = dot.textContent || "";
    dot.dataset.personalPrintTitle = dot.title || "";
  }

  function restoreOriginal(dot){
    if(dot.dataset.personalPrintSaved !== "1") return;
    dot.className = dot.dataset.personalPrintClass || "mts-workshop-state free";
    dot.textContent = dot.dataset.personalPrintText || "🟢";
    dot.title = dot.dataset.personalPrintTitle || "Libre";
    delete dot.dataset.personalPrintSaved;
    delete dot.dataset.personalPrintClass;
    delete dot.dataset.personalPrintText;
    delete dot.dataset.personalPrintTitle;
    delete dot.dataset.personalPrintActive;
  }

  function refreshCounter(){
    const bar = document.getElementById("mtsWorkshopBar");
    if(!bar) return;
    const dots = [...bar.querySelectorAll(".mts-workshop-state[data-printer-name]")];
    const printing = dots.filter(dot=>dot.classList.contains("printing") || dot.classList.contains("overdue")).length;
    const reserved = dots.filter(dot=>dot.classList.contains("reserved")).length;
    const counter = bar.querySelector(".mts-workshop-head span");
    const nextText = `${printing} en impression • ${reserved} réservée(s)`;
    if(counter && counter.textContent !== nextText) counter.textContent = nextText;
  }

  function apply(){
    const currentMachines = machines();
    if(!currentMachines.length) return;

    document.querySelectorAll(".mts-workshop-state[data-printer-name]").forEach(dot=>{
      const wanted = normalizedPrinterName(dot.dataset.printerName);
      const machine = currentMachines.find(item=>normalizedPrinterName(item.name || item.id) === wanted);
      if(machine && isPrinting(machine)){
        if(dot.dataset.personalPrintActive === "1") return;
        saveOriginal(dot);
        dot.classList.remove("free", "reserved", "overdue", "finish");
        dot.classList.add("printing");
        dot.textContent = "🟠 En cours";
        dot.title = "Impression détectée par le Connector";
        dot.dataset.personalPrintActive = "1";
      }else if(dot.dataset.personalPrintActive === "1"){
        restoreOriginal(dot);
      }
    });

    refreshCounter();
  }

  function start(){
    if(MTS.personalPrintStatusTimer) return;
    apply();
    // Projects reconstruit regulierement le bandeau avec innerHTML.
    // MutationObserver reapplique l'etat Connector dans la meme boucle du navigateur,
    // avant que le retour temporaire a "Libre" ne soit peint a l'ecran.
    let applyingMutation = false;
    MTS.personalPrintStatusObserver = new MutationObserver(mutations=>{
      if(applyingMutation) return;
      const workshopChanged = mutations.some(mutation=>
        mutation.target?.id === "mtsWorkshopBar" || mutation.target?.closest?.("#mtsWorkshopBar") ||
        [...(mutation.addedNodes || [])].some(node=>node.nodeType === 1 && (node.id === "mtsWorkshopBar" || node.querySelector?.("#mtsWorkshopBar")))
      );
      if(!workshopChanged) return;
      applyingMutation = true;
      apply();
      queueMicrotask(()=>{ applyingMutation = false; });
    });
    MTS.personalPrintStatusObserver.observe(document.body, {childList:true, subtree:true});
    // Verification silencieuse : aucune reecriture visuelle tant que l'etat ne change pas.
    MTS.personalPrintStatusTimer = window.setInterval(apply, 1500);
  }

  if(document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", ()=>window.setTimeout(start, 1200));
  }else{
    window.setTimeout(start, 1200);
  }

  MTS.PersonalPrintStatus = {apply, start};
})(window.MTS);
